import React from 'react';
import PropTypes from 'prop-types';

import PdfIcon from '../../../common/img/components/PdfIcon';
import PlayButton from '../../../common/img/components/PlayButton';

const FileItemPreview = ({
  containerClass = '',
  fileType,
  thumbnailUrl = '',
  thumbnailClass = '',
}) => {
  switch (fileType) {
    case 'video':
      return (
        <div className={containerClass}>
          <video className={thumbnailClass}>
            <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions" />
            <source src={thumbnailUrl} />
          </video>
        </div>
      );
    case 'image':
      return (
        <div className={containerClass}>
          <img className={thumbnailClass} src={thumbnailUrl} alt="preview" />
        </div>
      );
    case 'pdf':
      return <div className={containerClass}><PdfIcon /></div>;
    case 'embedded_video':
      return <div className={containerClass}><PlayButton /></div>;
    default:
      return <></>;
  }
};

FileItemPreview.propTypes = {
  containerClass: PropTypes.string,
  fileType: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  thumbnailClass: PropTypes.string,
};

export default FileItemPreview;
